module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/web3-eth-ens/~/websocket/index.js
// module id = 1879
// module chunks = 0 1 3